















































import Vue from 'vue';
import { IIcons, IStyleObject } from '@/common/interfaces/index.interface';
import TIcons from '@/types/TIcons';
import config from '../../../../config';

interface IAccordionItemRefs {
  accordionItemRef: HTMLDivElement;
}

interface IAccordionItemComponent {
  activeUid: number | null;
  icons: IIcons;
  isOpen: boolean;
  uid: number;
}

interface IAccordionItemInstance extends Vue {
  [`_uid`]: number;
}

export default Vue.extend({
  name: `AccordionItem`,
  data(): IAccordionItemComponent & { $refs?: IAccordionItemRefs } {
    return {
      activeUid: null,
      icons: TIcons,
      isOpen: false,
      uid: 0,
    };
  },
  computed: {
    bodyClass(): string {
      return (this.isOpen && (this.uid === this.activeUid)) ? `accordion-item__body--opened` : `accordion-item__body--closed`;
    },
    iconClass(): string {
      return (this.isOpen && (this.uid === this.activeUid)) ? `accordion-item__icon--opened` : `accordion-item__icon--closed`;
    },
    maxBodyHeight(): IStyleObject {
      return {
        maxHeight: this.uid === this.activeUid ? `${(this.$refs.accordionItemBody as Element).scrollHeight}px` : `0`,
      };
    },
  },
  props: {
    ignoreContentClick: {
      default: false,
      type: Boolean,
    },
    showPrintButton: {
      default: false,
      type: Boolean,
    },
    title: {
      default: ``,
      type: String,
    },
    titleStyle: {
      default: () => {},
      type: Object as () => IStyleObject,
    },
  },
  mounted(): void {
    if(this.$vnode.componentInstance) {
      const accordionItemInstance = this.$vnode.componentInstance as IAccordionItemInstance;
      // eslint-disable-next-line no-underscore-dangle
      this.uid = accordionItemInstance._uid;
    }
  },
  methods: {
    async handleClick(): Promise<void> {
      this.isOpen = !this.isOpen;
      if(this.isOpen) {
        window.setTimeout(() => {
          // visibility check code from https://vueuse.org/core/useElementVisibility/#source
          const rect = this.$refs.accordionItemRef.getBoundingClientRect();
          const isVisible = (
            rect.top <= (window.innerHeight || document.documentElement.clientHeight)
            && rect.left <= (window.innerWidth || document.documentElement.clientWidth)
            && rect.bottom >= 0
            && rect.right >= 0
          );
          if(!isVisible) {
            this.$refs.accordionItemRef.scrollIntoView({ behavior: `smooth`, block: `center` });
          } else if(window.innerWidth < config.breakpoints.maxMobile) {
            this.$refs.accordionItemRef.scrollIntoView({ behavior: `smooth`, block: `start` });
          }
        }, 300); // timeout should be the same as the animation duration in CSS to avoid the item being scrolled into view while the item is still opened, causing a layout shift
      }
      await this.$parent.$emit(`update:state`, this.uid);
    },
  },
});
